import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, Text } from '@olxbr/design-system'
import CapsLockIcon from '../../atoms/CapsLockIcon'

const Wrapper = styled(View)`
  display: flex;
  position: absolute;
  margin-left: 10px;
  align-items: center;
  justify-content: center;
`

const IconWrapper = styled(View)`
  margin-left: 6px;
  margin-right: 8px;
`

const TooltipBody = styled(View)`
  display: flex;
  align-items: center;
  padding: 6px;
  height: 32px;
  width: 40px;
  border: 1px solid #f9f9f9;
  border-radius: 8px;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 4px 5px 1px rgba(0, 0, 0, 0.1);
  &::after {
    z-index: -10;
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 0;
    bottom: 0;
    top: calc(50% - 6px);
    left: 0;
    border: 4px solid #ffffff;
    transform-origin: 0 0;
    transform: rotate(45deg);
    box-shadow: 0 4px 3px -2px rgba(0, 0, 0, 0.1);
  }
  &::before {
    z-index: 10;
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 0;
    bottom: 0;
    top: calc(50% - 6px);
    left: 0;
    border: 4px solid #ffffff;
    transform-origin: 0 0;
    transform: rotate(45deg);
    box-shadow: 0 4px 3px -2px rgba(0, 0, 0, 0.1);
  }
  :hover {
    display: flex;
    width: auto;
  }
`

const Message = styled(Text)`
  font-size: 14px;
  color: #999999;
  flex-direction: row;
`

const Highlight = styled(Message)`
  font-weight: 600;
  color: #4a4a4a;
`

class CapsLockTooltip extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hovering: false,
    }
    this.toggleHover = this.toggleHover.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
  }

  onMouseEnter() {
    const { lurker } = this.props
    if (lurker && typeof lurker.viewMessageEvt === 'function') {
      lurker.viewMessageEvt('caps_lock_tooltip_opened')
    }
    this.toggleHover()
  }

  toggleHover() {
    this.setState(prevState => ({ hovering: !prevState.hovering }))
  }

  renderMessage = (message, highlight) => {
    if (message.indexOf(highlight) === -1) {
      return <Message>{message}</Message>
    }
    return (
      <Message>
        {message.split(highlight).reduce((prev, current, i) => {
          if (!i) {
            return [current]
          }
          return prev.concat(<Highlight key={highlight + current}>{highlight}</Highlight>, current)
        }, [])}
      </Message>
    )
  }

  render() {
    const { message, highlight } = this.props
    return (
      <Wrapper>
        <TooltipBody onMouseEnter={this.onMouseEnter} onMouseLeave={this.toggleHover}>
          <IconWrapper>
            <CapsLockIcon />
          </IconWrapper>
          {this.state.hovering && this.renderMessage(message, highlight)}
        </TooltipBody>
      </Wrapper>
    )
  }
}

CapsLockTooltip.propTypes = {
  message: PropTypes.string.isRequired,
  highlight: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  lurker: PropTypes.object,
}

export default CapsLockTooltip
